const labelsHR = {
    "view": {
        "table": {
            "title": "Vaš popis etiketa",
            "column": {
                "name": "Ime",
                "owner": "Vlasnik",
                "company": "Tvrtka",
                "contract": "Ugovor",
                "info": "Informacije",
                "status": "Status",
                "action": "Akcija"
            },
            "button": {
                "edit": "Uredi",
                "export_csv": "Izvezi CSV"
            },
            "placeholder": {
                "search": "Pretraži..."
            },
            "label": {
                "approved": "Odobreno",
                "waiting_approval": "Čeka odobrenje"
            }
        },
        "message": {
            "success": "Etiketa je uklonjena!",
            "error": "Nešto je pošlo po zlu! Osvježite stranicu i pokušajte ponovno!",
            "notSubscribed": "Niste pretplaćeni ni na jedan plan, stoga možete dodati samo <strong>3 oznake</strong>. Molimo <3>pretplatite se</3> na plan kako biste imali neograničen broj oznaka.",
            "subscriptionUpgrade": "Vaš trenutni plan pretplate ne podržava ovu značajku. Molimo <1>nadogradite</1> svoj plan pretplate kako biste koristili ovu značajku.",
            "subscriptionExpired": "Vaša pretplata je istekla. Molimo <1>nastavite</1> svoju pretplatu kako biste koristili ovu značajku.",
            "noAccess": "Nemate pristup ovom modulu, molimo kontaktirajte tim za podršku za dodatne informacije."
        },
        "modal": {
            "delete": {
                "header": "Izbriši etiketu {{labelName}}?",
                "body": "Jeste li sigurni da želite izbrisati etiketu {{labelName}}? Ova akcija se ne može poništiti."
            }
        }
    },
    "add": {
        "title": "Dodaj etiketu",
        "form": {
            "label": {
                "required": "Obavezno",
                "name": "Ime",
                "subuser": "Pod-korisnik",
                "logo": "Logo",
                "promo_graphic": "Promotivna grafika",
                "primary_genre": "Primarni žanr",
                "secondary_genre": "Sekundarni žanr",
                "year_established": "Godina osnivanja",
                "releases_in_catalog": "Izdanja u katalogu",
                "soundcloud": "Soundcloud",
                "website": "Web stranica",
                "facebook": "Facebook",
                "twitter": "Twitter",
                "youtube": "Youtube",
                "instagram": "Instagram",
                "mixcloud": "Mixcloud",
                "beatport": "Beatport"
            },
            "help_text": {
                "subuser": "Napomena: Koristite ovaj padajući izbornik samo ako želite dodati etiketu za bilo kojeg od svojih pod-korisnika, inače ostavite neodabrano.",
                "logo": "Prenesite JPG ili PNG formate, rezolucija samo 1000x1000 px",
                "promo_graphic": "Prenesite JPG ili PNG formate, rezolucija samo 960x150px, max 100kb"
            },
            "placeholder": {
                "subuser": "Odaberite pod-korisnika..."
            },
            "button": {
                "reset": "Poništi",
                "submit": "Pošalji"
            },
            "message": {
                "success": "Etiketa je dodana!",
                "error": "Nešto je pošlo po zlu! Osvježite stranicu i pokušajte ponovno!"
            }
        },
        "modal": {
            "addLabel": {
                "header": "Dodaj etiketu {{labelName}}?",
                "body": "Jeste li sigurni da želite stvoriti novu etiketu? Molimo provjerite da unosite jedinstveno ime etikete. Kako biste bili sigurni, provjerite postoji li ime već u trgovinama kao što su Beatport i Traxsource. Svaka prijava mora biti odobrena i registrirana od strane Music Link tima. Obično odobravamo i registriramo nove etikete unutar 48 sati.",
                "button": {
                    "confirm": "Potvrdi",
                    "cancel": "Otkaži"
                }
            }
        },
        "message": {
            "success": "Etiketa je dodana!",
            "error": "Nešto je pošlo po zlu! Osvježite stranicu i pokušajte ponovno!"
        }
    },
    "update": {
        "title": "Uredi etiketu",
        "form": {
            "label": {
                "required": "Obavezno",
                "name": "Ime",
                "logo": "Logo",
                "promo_graphic": "Promotivna grafika",
                "primary_genre": "Primarni žanr",
                "secondary_genre": "Sekundarni žanr",
                "year_established": "Godina osnivanja",
                "releases_in_catalog": "Izdanja u katalogu",
                "soundcloud": "Soundcloud",
                "website": "Web stranica",
                "facebook": "Facebook",
                "twitter": "Twitter",
                "youtube": "Youtube",
                "instagram": "Instagram",
                "mixcloud": "Mixcloud",
                "beatport": "Beatport"
            },
            "help_text": {
                "logo": "Prenesite JPG ili PNG formate, rezolucija samo 1000x1000 px",
                "promo_graphic": "Prenesite JPG ili PNG formate, rezolucija samo 960x150px, max 100kb"
            },
            "placeholder": {},
            "button": {
                "submit": "Pošalji"
            },
            "message": {
                "success": "Etiketa je ažurirana!",
                "error": "Nešto je pošlo po zlu! Osvježite stranicu i pokušajte ponovno!"
            }
        }
    }
};

export default labelsHR;